<template>
    <section class="home-hero">
        <div class="home-hero__bg" :class="{'is-video': serviceID != null}"></div>
            <img 
                v-if="content.background_type != 'video' && content.background_image.url" 
                class="home-hero__bg__img"
                :src="content.background_image.url" 
                alt="">
            <div class="home-hero__video home-hero__video--bg"
                 v-if="content.background_type === 'video' && content.background_video">
                <video :src="content.background_video" loop playsinline muted></video>
            </div>
        <!-- <transition-group name="fade">
            <div class="home-hero__video home-hero__video--actives" :class="{'is-video-bg' : content.background_type === 'video'}"
                 v-for="itemVideo in content.services"
                 :key="itemVideo.service[0].ID"
                 v-show="itemVideo.service[0].ID === serviceID">
                <video :id="'video'+itemVideo.service[0].ID" :src="itemVideo.video" loop playsinline muted></video>
            </div>
        </transition-group> -->
        <div class="home-hero__container container">
            <div class="home-hero__wrapper">
                <div class="home-hero__content">
                    <div class="heading-small" v-html="content.heading_small_left"></div>
                    <div class="home-hero__title">
                        {{ content.title }}<span>.</span>
                    </div>
                    <button class="home-hero__popup-button" @click="showPopup()" v-if="content.video_button_label && content.showreel_video && content.video_button_label != ''">{{ content.video_button_label }}</button>
                </div>
                <div class="home-hero__nav">
                    <div class="heading-small" v-html="content.heading_small_right"></div>
                    <div class="home-hero__nav__item"
                         v-for="link in content.services"
                         :key="link.service[0].ID">
                        <a class="home-hero__nav__link"
                           :href="'/services/'+link.service[0].post_name"
                           :title="link.service[0].post_title"
                           @mouseenter="hover(link.service[0].ID)"
                           @mouseleave="serviceID = null"
                        >
                            <span class="home-hero__nav__link__text">{{ link.service[0].post_title }}</span>
                            <span class="home-hero__nav__link__text home-hero__nav__link__text--hover">{{ link.service[0].post_title }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <transition name="fade">
            <div v-show="content.showreel_video && isPopupOpenned" class="home-hero__popup">
                <svg class="home-hero__popup__play-icon" @click="playPopup()" viewBox="0 0 14 15">
                    <g transform="translate(14) rotate(90)" fill="none">
                        <path d="M7.5,0,15,14H0Z" stroke="none"/>
                        <path d="M 7.500000476837158 2.117650032043457 L 1.670169830322266 13.00000095367432 L 13.32983112335205 13.00000095367432 L 7.500000476837158 2.117650032043457 M 7.500000476837158 9.5367431640625e-07 L 15 14.00000095367432 L 9.5367431640625e-07 14.00000095367432 L 7.500000476837158 9.5367431640625e-07 Z" stroke="none" fill="#000"/>
                    </g>
                </svg>
                <video id="popupVideo" :src="content.showreel_video"></video>
                <button @click="hidePopup()" class="home-hero__popup__close_button is-active">
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
                <div class="home-hero__popup__controls">
                    <button @click="tooglePopupPlay()" class="home-hero__popup__btn" :class="{ 'isToggled' : !isPopupVideoPaused }">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15">
                            <g id="Polygon_2" data-name="Polygon 2" transform="translate(14) rotate(90)" fill="none">
                                <path d="M7.5,0,15,14H0Z" stroke="none"/>
                                <path d="M 7.500000476837158 2.117650032043457 L 1.670169830322266 13.00000095367432 L 13.32983112335205 13.00000095367432 L 7.500000476837158 2.117650032043457 M 7.500000476837158 9.5367431640625e-07 L 15 14.00000095367432 L 9.5367431640625e-07 14.00000095367432 L 7.500000476837158 9.5367431640625e-07 Z" stroke="none" fill="#fff"/>
                            </g>
                        </svg>
                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="15" viewBox="0 0 13 15">
                            <g id="Group_2" data-name="Group 2" transform="translate(1698 -1036)">
                                <g id="Rectangle_312" data-name="Rectangle 312" transform="translate(-1698 1036)" fill="none" stroke="#fff" stroke-width="1">
                                <rect width="5" height="15" stroke="none"/>
                                <rect x="0.5" y="0.5" width="4" height="14" fill="none"/>
                                </g>
                                <g id="Rectangle_313" data-name="Rectangle 313" transform="translate(-1690 1036)" fill="none" stroke="#fff" stroke-width="1">
                                <rect width="5" height="15" stroke="none"/>
                                <rect x="0.5" y="0.5" width="4" height="14" fill="none"/>
                                </g>
                            </g>
                        </svg>

                    </button>
                    <button @click="tooglePopupSound()" class="home-hero__popup__btn" :class="{ 'isToggled' : isPopupVideoMuted }">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29.89 24.3">
                            <rect fill="none" stroke="#ffffff" stroke-miterlimit="10" x="0.5" y="7.54" width="4.66" height="9.59"/>
                            <polygon fill="none" stroke="#ffffff" stroke-miterlimit="10" points="5.15 7.54 14.74 0.95 14.74 23.38 5.15 17.12 5.15 7.54"/>
                            <path fill="none" stroke="#ffffff" stroke-miterlimit="10" d="M20.22,6.79l.11.11a7.72,7.72,0,0,1,.06,10.63"/>
                            <path fill="none" stroke="#ffffff" stroke-miterlimit="10" d="M23.15,5.65a9.83,9.83,0,0,1,.1,13"/>
                            <path fill="none" stroke="#ffffff" stroke-miterlimit="10" d="M26.33,3.86a13,13,0,0,1,.12,16.61"/>
                        </svg>

                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.71 24.3">
                            <rect fill="none" stroke="#ffffff" stroke-miterlimit="10" x="0.5" y="7.54" width="4.66" height="9.59"/>
                            <polygon fill="none" stroke="#ffffff" stroke-miterlimit="10" points="5.16 7.54 14.75 0.95 14.75 23.38 5.16 17.12 5.16 7.54"/>
                            <line fill="none" stroke="#ffffff" stroke-miterlimit="10" x1="20.4" y1="8.42" x2="28.36" y2="16.39"/>
                            <line fill="none" stroke="#ffffff" stroke-miterlimit="10" x1="28.36" y1="8.42" x2="20.4" y2="16.39"/>
                        </svg>
                    </button>
                </div>
            </div>
        </transition>
    </section>
</template>
<script>
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import SplitText from "gsap/SplitText";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, SplitText);

export default {
    name: "home-hero",
    data() {
        return {
            serviceID: null,
            video: null,
            content: JSON.parse(this.hero),
            isPopupOpenned: false,
            isPopupVideoPaused: false,
            isPopupVideoMuted: false,
        }
    },

    props: {
        hero : [String, Object],
    },

    mounted() {
        this.playBGVideo();

        const params = new URLSearchParams(window.location.search)

        if ( params.has('showreel') ) {

            document.querySelector('.home-hero__popup__play-icon').style.display  = 'block';
            
            // const popupVideo = document.querySelector('#popupVideo');
            // popupVideo.src = '';
            setTimeout(() => {
                // document.querySelector('.home-hero__popup-button').click('click');
            //     // this.showPopup();
                this.isPopupOpenned = true;

            //     popupVideo.src = this.content.showreel_video;

            //     popupVideo.volume = 0;
            //     // popupVideo.muted = false;
            //     popupVideo.play();
            //         // popupVideo.play();
            //         // this.playPopup();
            //         // this.pausePopup();
            //     setTimeout(() => {
            //         popupVideo.volume = 1;
            //         // this.unmutePopup();
            //     }, 1000);
            }, 1000);

            // popupVideo.addEventListener('play', (event) => {
            //     popupVideo.volume = 0.5;
            // }); 
        }
    },

    created() {

    },

    watch: {
        serviceID: function (val) {
            if ( !val ) {
                const videos = document.querySelectorAll('.home-hero__video--actives video');

                videos.forEach((video) =>  {
                    video.pause();
                })
            }
        }
    },

    methods: {
        hover(ID) {
            // this.video = true;
            // this.serviceID = ID;

            // const videos = document.querySelectorAll('.home-hero__video--actives video');

            // videos.forEach((video) =>  {
            //     if ( video.id === 'video'+this.serviceID ) {
            //         video.play();
            //     } else {
            //         video.pause();
            //     }
            // })
        },
        playBGVideo() {
             const video = document.querySelector('.home-hero__video--bg video');
             video.play();
        },
        showPopup() {
            this.isPopupOpenned = true;
            this.playPopup();
        },
        hidePopup() {
            this.isPopupOpenned = false
            this.pausePopup();
        },

        tooglePopupPlay() {
            if(this.isPopupVideoPaused) {
                this.playPopup();
            } else {
                this.pausePopup();
            }
        },

        tooglePopupSound() {
            if(!this.isPopupVideoMuted) {
                this.mutePopup();
            } else {
                this.unmutePopup();
            }
        },

        mutePopup() {
            const popupVideo = document.querySelector('#popupVideo');
            popupVideo.muted = true;

            this.isPopupVideoMuted = true;
        },

        unmutePopup() {
            const popupVideo = document.querySelector('#popupVideo');
            popupVideo.muted = false;
            
            this.isPopupVideoMuted = false;
        },

        playPopup(){
            const popupVideo = document.querySelector('#popupVideo');
            popupVideo.play();
            this.isPopupVideoPaused = false;

            document.querySelector('.home-hero__popup__play-icon').style.display  = 'none';
        },

        pausePopup() {
            const popupVideo = document.querySelector('#popupVideo');
            popupVideo.pause();
            this.isPopupVideoPaused = true;
        }
    },
}
</script>
<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
    transition: opacity .75s ease 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    transition-delay: 0.2s;
    opacity: 0;
}
</style>